<template>
  <div class="main">
    <img id="bgImg" src="/img/bg.png">
    <div class="front">
      <a href="#" id="aLink">
        <img id="androidImg" src="/img/01.png">
      </a>
      <a href="#" id="iLink" @click="handleIOSClick">
        <img id="iosImg" src="/img/02.png">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
  methods: {
    handleIOSClick() {
      window.alert("开发中，敬请期待")
    },
  }
}

const handleScreenSize = function () {
  // const sw = window.screen.width
  const sw = document.body.clientWidth
  console.log(sw)
  const bgImg = document.getElementById("bgImg")
  const androidImg = document.getElementById("androidImg")
  const iosImg = document.getElementById("iosImg")
  bgImg.width = sw
  androidImg.width = sw / 1080 * 425
  iosImg.width = sw / 1080 * 425
  const fronts = document.getElementsByClassName("front")
  const items = Array.from(fronts)
  items.forEach(v => {
    console.log(v)
    const left = (sw - v.clientWidth) / 2
    console.log(left)
    v.style.left = left + "px"
  })
  items[0].style.bottom = bgImg.clientHeight * 50 / 1291 + "px"
}

window.onload = function () {
  const alink = document.getElementById("aLink")
  let cLink = document.getElementById("cLink").innerText
  if (cLink) {
    alink.setAttribute("href", cLink)
  } else {
    let oLink = document.getElementById("oLink").innerText
    alink.setAttribute("href", oLink)
  }
  handleScreenSize()
}
window.onresize = function () {
  handleScreenSize()
}
</script>

<style scoped>
.main {
  position: relative;
}

.front {
  position: absolute;
}
</style>
